import React, { useState } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import {useEnhancedTranslation} from "laravel-inertia-backend";


export default function AddressComparisonModal({
    show,
    onHide,
    deliveryWeclappAddress,
    deliveryOrderAddress,
    invoiceWeclappAddress,
    invoiceOrderAddress,
    showDelivery = false,
    showInvoice = false,
    onConfirm
}) {
    const {t} = useEnhancedTranslation();
    // Force no preselection to require explicit user choice
    const [selectedDelivery, setSelectedDelivery] = useState(null); // 'order' | 'weclapp' | null
    const [selectedInvoice, setSelectedInvoice] = useState(null); // 'order' | 'weclapp' | null

    const handleConfirm = () => {
        const useWeclappDelivery = showDelivery ? (selectedDelivery === 'weclapp') : false;
        const useWeclappInvoice = showInvoice ? (selectedInvoice === 'weclapp') : false;
        onConfirm(useWeclappDelivery, useWeclappInvoice);
        onHide();
    };

    const formatAddress = (address) => {
        if (!address) return null;
        return (
            <div>
                <p className="mb-0">
                    {address.firstName} {address.lastName}<br />
                    {address.street1} {address.street2 && <><br />{address.street2}</>}<br />
                    {address.zipcode} {address.city}<br />
                    {address.countryCode}
                    {address.phoneNumber && <><br />{address.phoneNumber}</>}
                </p>
            </div>
        );
    };

    const AddressOption = ({ title, address, value, type }) => {
        const selected = (type === 'delivery' ? selectedDelivery : selectedInvoice) === value;

        const onSelect = () => (type === 'delivery' ? setSelectedDelivery(value) : setSelectedInvoice(value));
        const onKeyDown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect();
            }
        };

        return (
            <div
                role="radio"
                aria-checked={selected}
                tabIndex={0}
                onClick={onSelect}
                onKeyDown={onKeyDown}
                className={
                    'p-3 border rounded mb-3 position-relative h-100 ' +
                    (selected ? 'border-weclapp bg-light shadow-sm' : '')
                }
                style={{ cursor: 'pointer' }}
            >
                <h5 className="mb-2">{title}</h5>
                {formatAddress(address)}
                <div className="d-flex justify-content-between align-items-center mt-2">
                    <small className="text-muted">
                        {value === 'order' ? t('Order address') : t('Weclapp address')}
                    </small>
                    {selected && (
                        <span className="badge bg-weclapp text-black">
                            {t('Selected')}
                        </span>
                    )}
                </div>
            </div>
        );
    };

    const needsDecisionDelivery = !!showDelivery;
    const needsDecisionInvoice = !!showInvoice;
    const confirmDisabled = (needsDecisionDelivery && !selectedDelivery) || (needsDecisionInvoice && !selectedInvoice);

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{t('Address Comparison')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className={"text-danger fw-bold"}>{t("Some addresses in Weclapp differ from the order. Please select which address to use for each section:")}</p>

                {showDelivery && (
                    <div className="mb-4">
                        <h5 className="mb-3">{t('Delivery address')}</h5>
                        <Row>
                            <Col md={6}>
                                <AddressOption
                                    title={t('Order Shipping Address')}
                                    address={deliveryOrderAddress}
                                    value="order"
                                    type="delivery"
                                />
                            </Col>
                            <Col md={6}>
                                <AddressOption
                                    title={t('Weclapp Delivery Address')}
                                    address={deliveryWeclappAddress}
                                    value="weclapp"
                                    type="delivery"
                                />
                            </Col>
                        </Row>
                    </div>
                )}

                {showInvoice && (
                    <div>
                        <h5 className="mb-3">{t('Invoice address')}</h5>
                        <Row>
                            <Col md={6}>
                                <AddressOption
                                    title={t('Order Billing Address')}
                                    address={invoiceOrderAddress}
                                    value="order"
                                    type="invoice"
                                />
                            </Col>
                            <Col md={6}>
                                <AddressOption
                                    title={t('Weclapp Invoice Address')}
                                    address={invoiceWeclappAddress}
                                    value="weclapp"
                                    type="invoice"
                                />
                            </Col>
                        </Row>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('Cancel')}
                </Button>
                <Button variant="weclapp" onClick={handleConfirm} disabled={confirmDisabled}>
                    {t('Confirm')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
